// extracted by mini-css-extract-plugin
module.exports = {"smallIcon":"Icons_smallIcon__2GbLi","tinyIcon":"Icons_tinyIcon__BQO4f"};